export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10102.a85306d8.jpg";